import { createListActionTypes, concatSuggestions } from './Constants';
import { LIST_ITEM_STATUS } from '../../services/Constants';
import shortid from 'shortid';

const initialState = {
	loading: false,
	createListLoading: false,
	subjects: [],
	availableListTypes: [],
	suggestions: [],
	locales: null,
	createdListId: null,
	list: {
		id: null,
		status: LIST_ITEM_STATUS.DRAFT,
		shared: true,
		words_collection: Array(10)
			.fill()
			.map((_, i) => ({
				id: i + 1,
				words: ['', ''],
				image_url: null,
			})),
	},
	imageOverviewModal: {
		open: false,
		itemId: null,
		deletedItemId: null,
		image: null,
	},
	importModal: {
		open: false,
		importedWords: null,
	},
	listWords: [],
	listVisibility: null,
	existingChapters: [],
	languages: [],
	listOptionsLoading: false,
	loadingWordlistImage: false,
	aiGeneratedWords: [],
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		listOptions,
		suggestions,
		createdList,
		listDetails,
		modalStatus,
		itemId,
		image,
		open,
		deletedItemId,
		importedWords,
		listWords,
		newChapter,
		data,
		generatedByAI,
	} = payload || {};

	switch (type) {
		case createListActionTypes.LIST_OPTIONS_REQUEST:
			return {
				...state,
				loading: true,
				listOptionsLoading: true,
			};

		case createListActionTypes.WORD_SUGGESTION_REQUEST:
		case createListActionTypes.DELETE_DRAFT_LIST_REQUEST:
		case createListActionTypes.EDIT_LIST_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};

		case createListActionTypes.UPLOAD_WORDLIST_IMAGE_REQUEST:
			return {
				...state,
				loadingWordlistImage: true,
			};
		case createListActionTypes.UPLOAD_WORDLIST_IMAGE_SUCCESS:
		case createListActionTypes.UPLOAD_WORDLIST_IMAGE_ERROR:
			return {
				...state,
				loadingWordlistImage: false,
			};

		case createListActionTypes.CREATE_LIST_REQUEST:
			return {
				...state,
				createListLoading: true,
			};

		case createListActionTypes.LIST_OPTIONS_SUCCESS:
			const { available_list_types, existing_chapters, visibility, ...rest } =
				listOptions || {};
			return {
				...state,
				loading: false,
				listOptionsLoading: false,
				availableListTypes: available_list_types,
				existingChapters: existing_chapters,
				listVisibility: visibility,
				...rest,
			};

		case createListActionTypes.WORD_SUGGESTION_SUCCESS:
			return {
				...state,
				loading: false,
				suggestions: concatSuggestions(state.suggestions, suggestions),
			};

		case createListActionTypes.CREATE_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				createListLoading: false,
				createdListId: createdList.id,
				draftedCount: createdList.words_collection.length,
				aiGeneratedWords: generatedByAI ? createdList.words_collection : [],
			};
		case createListActionTypes.CREATE_LIST_ERROR:
			return {
				...state,
				loading: false,
				createListLoading: false,
			};

		case createListActionTypes.DELETE_DRAFT_LIST_SUCCESS:
			return initialState;

		case createListActionTypes.EDIT_LIST_DATA_SUCCESS:
			const { words_collection, locales, subject, ...others } = listDetails || {};
			return {
				...state,
				loading: false,
				list: {
					...others,
					words_collection: [
						...words_collection.map((item) => ({
							...item,
							id: shortid.generate(),
						})),
					],
				},
				draftedCount: words_collection.length,
				locales,
				subject,
			};

		case createListActionTypes.LIST_OPTIONS_ERROR:
		case createListActionTypes.WORD_SUGGESTION_ERROR:
			return {
				...state,
				loading: false,
			};

		case createListActionTypes.SET_IMAGE_OVERVIEW_MODAL:
			return {
				...state,
				imageOverviewModal: {
					open: modalStatus,
					itemId,
					image,
					deletedItemId,
				},
			};
		case createListActionTypes.DELETE_UPLOADED_IMAGE:
			return {
				...state,
				uploadedImage: {
					itemId: null,
					publicLink: null,
				},
			};
		case createListActionTypes.TOGGLE_IMPORT_MODAL:
			return {
				...state,
				importModal: {
					open,
					importedWords,
				},
			};
		case createListActionTypes.SET_LIST_WORDS:
			return {
				...state,
				listWords: [...listWords],
			};
		case createListActionTypes.SET_NEW_CREATED_CHAPTER:
			return {
				...state,
				existingChapters: [...state.existingChapters, ...[newChapter]],
			};
		case createListActionTypes.SET_CREATE_LIST_PRESELECTED_OPTIONS:
			return {
				...state,
				...data,
			};
		case createListActionTypes.CLEAN_LIST_STATE:
			return initialState;

		default:
			return state;
	}
}
